import React from 'react';

import { useGasparCookies } from '../../providers/GasparCookiesProvider/GasparCookiesProvider';
import { siteCookiesDescriptions } from '../../providers/GasparCookiesProvider/constants';
import { SiteCookie } from '../../providers/GasparCookiesProvider/types';
import FormToggle from './FormToggle';

const ManageCookiesForm: React.FC = React.memo(() => {
  const { cookies, toggleCookie } = useGasparCookies();
  return (
    <div className="text-center flex flex-col my-2 gap-2">
      {Object.entries(cookies).map(([cookie, value]) => (
        <div
          key={cookie}
          className="flex px-4 py-3 gap-2 justify-between items-center md:items-start text-left bg-pureWhite/10 rounded-2xl"
        >
          <p>
            <span className="font-bold">{cookie}:</span>
            <span>{siteCookiesDescriptions[cookie as SiteCookie]}</span>
          </p>
          <div>
            <FormToggle label="Analytics" id="analytics" checked={value == true} onChange={() => toggleCookie(cookie as SiteCookie)} />
          </div>
        </div>
      ))}
    </div>
  );
});
ManageCookiesForm.displayName = 'ManageCookiesForm';
export default ManageCookiesForm;
